if (!customElements.get('swiss-shipping')) {
  customElements.define('swiss-shipping', class extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.productForm) return;
      this.productInfo = this.closest('product-info');
      this.variants = JSON.parse(this.querySelector('[data-shipping-variants]').textContent);
      this.onChange = () => this.update();
      this.productInfo?.addEventListener('change', this.onChange);
      if (typeof subscribe === 'function') {
        this.unsubscribeQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.onChange);
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (String(data.sectionId) !== this.productInfo?.dataset.section) return;
          this.dataset.variant = data.variant?.id || '';
          this.update();
        });
      }
      this.update();
    }
    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onChange);
      this.unsubscribeQuantity?.();
      this.unsubscribeVariant?.();
    }
    update() {
      const form = document.getElementById(this.dataset.productForm);
      const id = form?.querySelector('[name="id"]')?.value || this.dataset.variant;
      const variant = this.variants.find(item => String(item.id) === String(id));
      this.hidden = !variant?.requires_shipping;
      if (this.hidden) return;
      const quantity = Math.max(1, Number(this.productInfo?.querySelector('[name="quantity"]')?.value || 1));
      const subtotal = variant.price * quantity;
      const weight = variant.weight * quantity;
      const fee = subtotal >= 5000 ? 0 : weight <= 2000 ? 750 : weight >= 2001 && weight <= 10000 ? 1050 : weight > 10000 && weight <= 30000 ? 1950 : -1;
      const format = value => new Intl.NumberFormat(this.dataset.locale || 'de-CH', { style: 'currency', currency: 'CHF', currencyDisplay: 'code' }).format(value / 100);
      this.querySelector('[data-shipping-fee]').textContent = fee === 0 ? this.dataset.free : fee > 0 ? format(fee) : this.dataset.checkoutText;
      this.querySelector('[data-shipping-total-row]').hidden = fee < 0;
      this.querySelector('[data-shipping-total]').textContent = fee >= 0 ? format(subtotal + fee) : '';
    }
  });
}
